// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"ProductSingleBreadcrumbs_breadcrumbs__7G2jT"};